import { Component, OnInit } from '@angular/core';

import { CtbCtaService, PageBusquedaObject, CtbCtaDto } from '../../ctb-cta/ctb-cta.service';
import { LoginService } from '../../../login/login.service';
import { ActFijoService } from '../act-fijo.service';
import Swal from 'sweetalert2';
import { Router, ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-component-act-fijo',
  templateUrl: './component-act-fijo.component.html',
  styleUrls: ['./component-act-fijo.component.css']
})
export class ComponentActFijoComponent implements OnInit {
  cargado: boolean;
  dto: any = {
    ctb_cta_id: 0,val_max_depr_c:1,depreciado_c:false, concepto_baja_f: 1, concepto_baja_c: 1, depreciacion_c: 0, deduccion_c: 100
    , depreciacion_f: 0, deduccion_f: 100, dep_fis: false, dep_cta: true, baja_f: false
    , monto_agregado_tmp: 0, vida_util_c: 1, vida_util_f: 1, baja_c: false, depreciacion_acomulada_c: 0,
    depreciacion_acomulada_f: 0, monto_original: 0, monto_agregado: 0, ded_inm_fis_f: 100,valor_residual_c: 1, dep_bin_ded_f: 0,
    ded_fis_checked: false
  };
  cuentas: CtbCtaDto[];
  public id_param: number;
  busquedaCuenta: PageBusquedaObject = new PageBusquedaObject();
  constructor(private activatedRoute: ActivatedRoute, public loginService: LoginService,
    private service: ActFijoService, private router: Router) { }

  ngOnInit(): void {
    this.busquedaCuenta.criteriaSearch = {};
    this.busquedaCuenta.itemsPerPage = 5;
    this.busquedaCuenta.pageNumber = 0;
    this.cargado = true;
    this.fechasDefault();
    this.cargarFormulario();
    this.jqueryCodigo();
  }

  jqueryCodigo(){
  }
  asignarFechasIniciales() {
    this.dto.fecha_inicio_uso_c = this.dto.fecha_adquisicion;
    this.dto.fecha_ultima_dep_c = this.dto.fecha_adquisicion;

  }
  ValidaSoloNumeros() {
    var e = e || window.event;
    //e.preventDefault();
    if ((e.keyCode < 46) || (e.keyCode > 57)) {
      e.returnValue = false;
      e.preventDefault();
    }
    if (this.dto.depreciacion_c > 100) {
      this.dto.depreciacion_c = 100;
    }
    if (this.dto.deduccion_c > 100) {
      this.dto.deduccion_c = 100;
    }
    if (this.dto.depreciacion_f > 100) {
      this.dto.depreciacion_f = 100;
    }
    if (this.dto.deduccion_f > 100) {
      this.dto.deduccion_f = 100;
    }
  }
  fechasDefault() {
    const fecha = this.fechaActual();
    this.dto.fecha_adquisicion = fecha;
    this.dto.fecha_inicio_uso_c = fecha;
    this.dto.fecha_ultima_dep_c = fecha;
    this.dto.fecha_baja_c = fecha;
    this.dto.fecha_inicio_uso_f = fecha;
    this.dto.fecha_ultima_dep_f = fecha;
    this.dto.fecha_baja_f = fecha;
  }
  calcularMontoMaximoDepreciable(){
    this.dto.val_max_depr_c = this.dto.monto_original - this.dto.valor_residual_c;
  }
  validadorCampos(){
    if (this.dto.depreciacion_c > 100) {
      this.dto.depreciacion_c = 100;
    }
    if (this.dto.deduccion_c > 100) {
      this.dto.deduccion_c = 100;
    }

    if(this.dto.val_max_depr_c <= 0){
      this.dto.val_max_depr_c = 1;
    }
    if(this.dto.val_max_depr_c > this.dto.monto_original - this.dto.valor_residual_c && this.dto.monto_original > 0){
      this.dto.val_max_depr_c = this.dto.monto_original - this.dto.valor_residual_c;
    }
    
    if (this.dto.valor_residual_c <= 0) {
      this.dto.valor_residual_c = 1;
    }
  }
  fechaActual(): String {
    const d = new Date();
    const currDate = d.getDate();
    const currMonth = d.getMonth() + 1;
    const currYear = d.getFullYear();
    return currYear + '-' + ((currMonth < 10) ? '0' + currMonth : currMonth) + '-' + ((currDate < 10) ? '0' + currDate : currDate);
  }
  asignarCuenta(campo: String, buscar: String) {
    this.busquedaCuenta.criteriaSearch = {};

    switch (campo) {
      case 'activo_fijo':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 1;
        break;
      case 'cuenta_iva_acreditable':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 1;
        break;
      case 'cuenta_proveedor_banco':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 1;
        break;
      case 'cuenta_depreciacion_c':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 1;
        break;
      case 'cuenta_de_gastos_c':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 5;
        break;
      case 'cuenta_no_deducibles_c':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 6;
        break;
      case 'cuenta_depreciacion_f':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 1;
        break;
      case 'cuenta_de_gastos_f':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 5;
        break;
      case 'cuenta_no_deducibles_f':
        // this.busquedaCuenta.criteriaSearch['tipo'] = 6;
        break;
    }

    this.busquedaCuenta.criteriaSearch['clasificacion'] = 4;
    switch (this.detectarNumero(buscar.replace('-', ''))) {
      case true:
        this.busquedaCuenta.criteriaSearch['cuenta'] = buscar.split(' - ')[0];
        this.busquedaCuenta.criteriaSearch['nombre'] = '';
        break;
      case false:
        this.busquedaCuenta.criteriaSearch['cuenta'] = '';
        this.busquedaCuenta.criteriaSearch['nombre'] = buscar.split(' - ')[1];
        break;
    }
    this.busquedaCuenta.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busquedaCuenta.criteriaSearch['emp'] = this.loginService.empresa;
    this.service.ctaCatalogo(this.busquedaCuenta).subscribe(response => {
      this.cuentas = response.contenido.content;
      if (this.cuentas != null && this.cuentas.length === 1) {
        let nombre_cuenta = '';
        switch (this.detectarNumero(buscar.replace('-', ''))) {
          case true:
            if (this.busquedaCuenta.criteriaSearch['cuenta'] === this.cuentas[0].cuenta) {
              nombre_cuenta = this.cuentas[0].cuenta + ' - ' + this.cuentas[0].nombre;
            }
            break;
          case false:
            if (this.busquedaCuenta.criteriaSearch['nombre'] === this.cuentas[0].nombre) {
              nombre_cuenta = this.cuentas[0].cuenta + ' - ' + this.cuentas[0].nombre;
            }
            break;
        }
        switch (campo) {
          case 'activo_fijo':
            this.dto.ctb_cta_id = this.cuentas[0].id;
            this.dto.cuenta_activo_fijo = nombre_cuenta;
            break;
          case 'cuenta_iva_acreditable':
            this.dto.cta_iva_acr = this.cuentas[0].id;
            this.dto.cuenta_iva_acreditable = nombre_cuenta;
            break;
          case 'cuenta_proveedor_banco':
            this.dto.cta_pro_ban = this.cuentas[0].id;
            this.dto.cuenta_proveedor_banco = nombre_cuenta;
            break;
          case 'cuenta_depreciacion_c':
            this.dto.cuenta_depreciacion_c = nombre_cuenta;
            this.dto.cta_depr_id_c = this.cuentas[0].id;
            break;
          case 'cuenta_de_gastos_c':
            this.dto.cuenta_de_gastos_c = nombre_cuenta;
            this.dto.cta_gast_id_c = this.cuentas[0].id;
            break;
          case 'cuenta_no_deducibles_c':
            this.dto.cuenta_no_deducibles_c = nombre_cuenta;
            this.dto.cta_no_ded_id_c = this.cuentas[0].id;
            break;
          case 'cuenta_depreciacion_f':
            this.dto.cuenta_depreciacion_f = nombre_cuenta;
            this.dto.cta_depr_id_f = this.cuentas[0].id;
            break;
          case 'cuenta_de_gastos_f':
            this.dto.cuenta_de_gastos_f = nombre_cuenta;
            this.dto.cta_gast_id_f = this.cuentas[0].id;
            break;
          case 'cuenta_no_deducibles_f':
            this.dto.cuenta_no_deducibles_f = nombre_cuenta;
            this.dto.cta_no_ded_id_f = this.cuentas[0].id;
            break;
        }
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
    this.cuentas = [];
  }

  detectarNumero(texto: String): boolean {
    const numeros = '0123456789';
    for (let i = 0; i < texto.length; i++) {
      if (numeros.indexOf(texto.charAt(i), 0) !== -1) {
        return true;
      }
    }
    return false;
  }

  crear() {
    if (this.validarCuentaNoDeducible) {
      this.dto.gral_usr_crea_id = this.loginService.usuario.id as number;
      this.dto.gral_emp_id = this.loginService.empresa as number;
      this.dto.fecha_ultima_dep_c =   this.dto.fecha_inicio_uso_c;
      this.service.post(this.dto, this.loginService.usuario.id as number).subscribe(response => {
        Swal.fire('TNK Ledger', response.mensaje, 'success');
        this.router.navigate(['/contabilidad/catalogo/act-fijo']);
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
      });
    }
  }
  actualizar() {
    if (this.validarCuentaNoDeducible) {
      this.dto.gral_usr_actualiza_id = this.loginService.usuario.id as number;
      this.dto.fecha_ultima_dep_c =   this.dto.fecha_inicio_uso_c;
      this.service.put(this.dto, this.loginService.usuario.id as number).subscribe(response => {
        Swal.fire('TNK Ledger', response.mensaje, 'success');
        this.router.navigate(['/contabilidad/catalogo/act-fijo']);
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        })
        console.log(err);
      });
    }
  }
  cargarFormulario() {
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.mostrarMensajeCarga();
        this.service.get(this.id_param).subscribe(response => {
          this.dto = response.contenido;
          console.log(response);
          this.cerrarMensajeCarga();
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }


  validarCuentaNoDeducible(): boolean {
    if (this.dto.cuenta_no_deducibles_c == '' || this.dto.cuenta_no_deducibles_c == null) {
      Swal.fire({
        title: 'TNK Ledger',
        text: `¿Desea manejar el 100% de la deducción?`,
        showCancelButton: true,
        confirmButtonText: 'Sí',
        cancelButtonText: 'No'
      }).then((result) => {
        if (result.value) {
          this.dto.deduccion_c = 100;
          return true;
        }
      });
      return false;
    }
    return true;
  }
}
